import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useMediaQuery } from '@mui/system';
import { Drawer } from '@mui/material';
import { Col } from 'react-bootstrap';
import VehicleTrackingDetailSection from 'src/components/VehicleTrackingDetails/VehicleTrackingDetailSection';
import HeaderSectionWrapper from 'src/components/VehicleTrackingDetails/HeaderSection/HeaderSectionWrapper';
import VehicleTrackingTimelineDesktop from 'src/components/VehicleTrackingDetails/VehicleTrackingTimeLine/VehicleTrackingTimelineDesktop';
import VehicleTrackingContentFormWrapper from 'src/components/VehicleTrackingDetails/VehicleTrackingContentForm/VehicleTrackingContentFormWrapper';
import TargetVsActualFormWrapper from 'src/components/VehicleTrackingDetails/TargetVsActualForm/TargetVsActualFormWrapper';
import GoodsReceivedNotesWrapper from 'src/components/VehicleTrackingDetails/GoodsReceivedNotesForm/GoodsReceivedNotesWrapper';
import 'src/style/targetvsactualv2.css';

function VehicleTrackingDetailPage() {
  const { workflowStageId, vehicleTrackingNumber } = useParams();
  const isMobile = useMediaQuery('(max-width:600px)');

  const [openAddVehicleContentDrawer, setOpenAddVehicleContentDrawer] =
    useState(false);
  const [createLoadTabActive, setCreateLoadTabActive] = useState(0);
  const [isGrnDrawerOpen, setIsGrnDrawerOpen] = useState(false);
  const [selectedTargetVsActualConfig, setOpenTargetVsActualForm] = useState(
    {},
  );

  const toggleGrnDrawer = (state) => {
    setIsGrnDrawerOpen(state ?? !isGrnDrawerOpen);
  };

  const toggleAddVehicleContentDrawer = () => {
    setOpenAddVehicleContentDrawer((prev) => !prev);
  };

  const toggleTargetVsActualForm = (config) => {
    setOpenTargetVsActualForm(config);
  };

  const handleVehicleContentDrawerClose = () => {
    setOpenAddVehicleContentDrawer(false);
  };

  const openCreateLoadTab = () => {
    setCreateLoadTabActive((prev) => prev + 1);
  };

  return (
    <>
      <div className="page-layout">
        <HeaderSectionWrapper
          toggleAddVehicleContentDrawer={toggleAddVehicleContentDrawer}
          openCreateLoadTab={openCreateLoadTab}
          toggleTargetVsActualForm={toggleTargetVsActualForm}
          toggleGrnDrawer={toggleGrnDrawer}
        />

        <div
          className={`d-flex main-vehicle-tracking-detail-v2-container ${isMobile ? '' : ' justify-content-center'}`}
        >
          {!isMobile && (
            <Col xxxl={2} xxl={2} xl={2} sm={2} xs={2} md={2} lg={2}>
              <VehicleTrackingTimelineDesktop
                workFlowStageId={workflowStageId}
              />
            </Col>
          )}
          <Col xxxl={10} xxl={10} xl={10} sm={10} xs={10} md={10} lg={10}>
            <VehicleTrackingDetailSection
              vehicleTrackingNumber={vehicleTrackingNumber}
              workflowStageId={workflowStageId}
              vehicleFormFunction={toggleAddVehicleContentDrawer}
              openCreateLoadTab={openCreateLoadTab}
              createLoadTabActive={createLoadTabActive}
            />
          </Col>
        </div>
      </div>

      <Drawer
        anchor="right"
        open={Boolean(openAddVehicleContentDrawer)}
        onClose={handleVehicleContentDrawerClose}
        ModalProps={{ keepMounted: false }}
        sx={{ zIndex: 1 }}
        PaperProps={{ sx: { width: isMobile ? '100%' : '80%' } }}
      >
        <VehicleTrackingContentFormWrapper
          toggleAddVehicleContentDrawer={handleVehicleContentDrawerClose}
        />
      </Drawer>

      <Drawer
        anchor="right"
        open={Object.keys(selectedTargetVsActualConfig || {}).length > 0}
        onClose={() => toggleTargetVsActualForm({})}
        ModalProps={{ keepMounted: false }}
        sx={{ zIndex: 1 }}
        PaperProps={{ sx: { width: isMobile ? '100%' : '80%' } }}
      >
        <TargetVsActualFormWrapper
          toggleTargetVsActualForm={toggleTargetVsActualForm}
          selectedTargetVsActualConfig={selectedTargetVsActualConfig}
        />
      </Drawer>

      <Drawer
        anchor="right"
        open={Boolean(isGrnDrawerOpen)}
        onClose={() => toggleGrnDrawer(false)}
        ModalProps={{ keepMounted: false }}
        sx={{ zIndex: 1 }}
        PaperProps={{ sx: { width: isMobile ? '100%' : '80%' } }}
      >
        <GoodsReceivedNotesWrapper toggleGrnDrawer={toggleGrnDrawer} />
      </Drawer>
    </>
  );
}

export default VehicleTrackingDetailPage;
